import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { List, Map, Record } from 'immutable';
import { ProjectPlatform } from '../../../../../workflow/entities/IWorkflowItem';

interface IBaseProcess {
	projectId: string;
	projectName: string;
	count: number;
	flowName: string;
	flowId?: string;
	id: string;
	projectPlatform: ProjectPlatform;
}

export interface IProcess extends IBaseProcess {
	projectCaption: IDictionary<string>;
	flowCaption: IDictionary<string>;
	latestFastApproves?: Array<number>;
}

export interface IReadonlyProcess extends IBaseProcess {
	projectCaption: Map<string, string>;
	flowCaption: Map<string, string>;
	latestFastApproves?: List<number>;
}

export type Process = ReadonlyRecord<IReadonlyProcess>;

export const ProcessFactory = Record<IReadonlyProcess>({
	id: null,
	projectId: null,
	projectName: null,
	flowName: null,
	flowId: null,
	count: 0,
	projectCaption: Map<string, string>(),
	flowCaption: Map<string, string>(),
	projectPlatform: 0,
	latestFastApproves: List()
});

export const ProcessFactoryFromJS = function (data: IProcess) {
	return ProcessFactory({
		...data,
		projectCaption: Map(data.projectCaption),
		flowCaption: Map(data.flowCaption),
		latestFastApproves: List(data.latestFastApproves || [])
	});
};
